import { useContext, useEffect } from 'react';
import { GameContext } from '../../contexts/GameContext.tsx';
import Grid from '../../components/Grid.tsx';

export default function SurvivalGame() {
  const gameContext = useContext(GameContext);

  useEffect(() => {
    gameContext?.startGame();
  }, [gameContext?.startGame]);

  if (!gameContext) return null;

  return (
    <div className="game-container">
      <div className="game-grid-area">
        <Grid />
      </div>
    </div>
  );
}
